import type { CSSProperties } from 'react';

const wrapperStyle: CSSProperties = {
  maxWidth: '720px',
  margin: '0 auto',
  padding: 'var(--loop-space-400)',
  color: 'var(--loop-neutral-1100)',
};

export function AboutReactions() {
  return (
    <article style={wrapperStyle}>
      <h1>About Diff Vader reactions</h1>

      <p>When Diff Vader posts a finding on your PR, you can react with three native GitHub emojis. We use them to calibrate the bot.</p>

      <h2>What each reaction means</h2>
      <ul>
        <li><strong>👍</strong> — good catch, this finding is helpful</li>
        <li><strong>👎</strong> — false positive, noise, or unhelpful</li>
        <li><strong>😕</strong> — debatable / I&apos;m not sure</li>
      </ul>

      <h2>What about the other GitHub reactions?</h2>
      <p>GitHub also offers ❤️ 🚀 🎉 😄 👀. <strong>Diff Vader silently ignores those</strong> — they don&apos;t count as 👍. We picked a small fixed set so the digest math stays meaningful. If you really want to flag something, leave a comment.</p>

      <h2>Where do they go?</h2>
      <p>Reactions on Diff Vader&apos;s <em>per-finding line comments</em> are captured. Reactions on the top-level review summary are <strong>not</strong> tracked — too ambiguous (could mean wrong verdict, too verbose, etc.).</p>

      <p>Each week the system clusters 👎 reactions by reviewer skill and surfaces the patterns to the EM/TL on rotation. They can dismiss (which creates a 90-day suppression silencing that pattern across the org — see the <a href="/suppressions">Suppressions</a> page), open a draft PR to refine the reviewer&apos;s prompt, or open a draft PR to adjust central policy. The bot never edits its own prompts directly — humans review every change.</p>

      <h2>Bots can&apos;t react</h2>
      <p>Reactions from <code>dependabot[bot]</code>, <code>copilot-pull-request-reviewer[bot]</code>, etc. are dropped at ingest. Only humans calibrate the bot.</p>

      <h2>How long do reactions live?</h2>
      <p>Reactions feed the weekly digest. Once an EM/TL has reviewed a digest, the cluster is closed for action — but the underlying reaction data stays in the audit trail. Patterns that recur will resurface in fresh digests; stale digests (more than six weeks old) are locked from action so the EM/TL works on current signal.</p>
    </article>
  );
}
